



















































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateDeviceWaringValue from "./createdevicewaringvalue.vue";
import EditDeviceWaringValue from "./editdevicewaringvalue.vue";
import CopyDeviceWaringValue from "./copydevicewaringvalue.vue";
import checkAuth from "@/lib/Common/checkauth";
import "@/assets/css/table.css";

class PageCollectorRequest extends PageRequest {
  keyword: string;
  areaId: number;
  CollectorType: number = 0;
  isp: number = 0;
  isEnabel: number = 9; //nullable
}

@Component({
  components: {
    CreateDeviceWaringValue,
    EditDeviceWaringValue,
    CopyDeviceWaringValue,
  },
})
export default class devicewaringvalue extends AbpBase {
  //检测按钮权限
  checkButtonAuth(tag: string) {
    return checkAuth.CheckButton(tag);
  }
  edit() {
    this.editModalShow = true;
  }
  //复制
  async copy() {
    this.copyModalShow = true;
  }
  //filters
  pagerequest: PageCollectorRequest = new PageCollectorRequest();
  searchName: string = ""; //树形搜索名称
  areaTree: any[] = [];
  areaTreeList: any[] = [];
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  copyModalShow: boolean = false;
  splitnum: number = 0.15;

  //改变排序
  changeSort(key) {
    if (key.order !== "normal") {
      this.pagerequest.sorting = key.key + " " + key.order;
    }
    this.getpage();
  }
  get list() {
    return this.$store.state.devicewaringvalue.list;
  }
  get loading() {
    return this.$store.state.devicewaringvalue.loading;
  }
  create() {
    this.createModalShow = true;
  }
  isActiveChange(val: number) {
    this.pagerequest.isEnabel = val;
    this.$store.commit("devicewaringvalue/setCurrentPage", 1);
    this.getpage();
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.pagerequest.areaId = item[0].id;
    }
    this.$store.commit("devicewaringvalue/setCurrentPage", 1);
    this.getpage();
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.areaTree = this.areaTreeList;
      return;
    }
    const rebuildData = (value, treeList) => {
      let newarr = [];
      treeList.forEach((element) => {
        if (element.children && element.children.length) {
          if (element.title != null && element.title.indexOf(value) > -1) {
            element.expand = true;
            newarr.push(element);
          }
          const ab = rebuildData(value, element.children);
          const obj = {
            ...element,
            expand: true,
            children: ab,
          };
          if (ab && ab.length) {
            newarr.push(obj);
          }
        } else {
          if (element.title != null && element.title.indexOf(value) > -1) {
            newarr.push(element);
          }
        }
      });
      return newarr;
    };
    this.areaTree = [];
    this.areaTree = rebuildData(value, this.areaTreeList);
  }
  async getAreaTree() {
    await this.$store
      .dispatch("area/getAreaLeftTree")
      .then((val) => {
        this.areaTree = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  pageChange(page: number) {
    this.$store.commit("devicewaringvalue/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("devicewaringvalue/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "devicewaringvalue/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.devicewaringvalue.pageSize;
  }
  get totalCount() {
    return this.$store.state.devicewaringvalue.totalCount;
  }
  get currentPage() {
    return this.$store.state.devicewaringvalue.currentPage;
  }
  columns = [
    {
      type: "index",
      width: 60,
      align: "left",
      fixed: "left",
      title: this.L("IndexNo"),
    },
    {
      title: this.L("Organizations"),
      key: "organizationId",
      width: 160,
      render: (h: any, params: any) => {
        let id = params.row.organizationId;
        let ite = JSON.parse(localStorage.getItem("organizations"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          info.length > 0 ? info[0].displayName : this.L("Unknown")
        );
      },
    },
    {
      title: this.L("Areas"),
      key: "areaId",
      width: 160,
      sortable: true,
      render: (h: any, params: any) => {
        let id = params.row.areaId;
        let ite = JSON.parse(localStorage.getItem("areas"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          info.length > 0 ? info[0].fullName : this.L("Unknown")
        );
      },
    },
    {
      sortable: true,
      width: 160,
      fixed: "left",
      title: this.L("Name"),
      key: "name",
    },
    {
      sortable: true,
      width: 130,
      title: this.L("AlarmPeriod"),
      key: "waringType",
      render: (h: any, params: any) => {
        let str = this.L("Unknow");
        let wt = params.row.waringType;
        switch (wt) {
          case 1:
            str = this.L("WaringHour");
            break;
          case 2:
            str = this.L("WaringDay");
            break;
          default:
            break;
        }
        return h("span", str);
      },
    },
    {
      title: this.L("MaxValue0"),
      key: "t0Max",
      width: 130,
    },
    {
      title: this.L("MinValue0"),
      key: "t0Min",
      width: 130,
    },
    {
      title: this.L("MaxValue1"),
      key: "t1Max",
      width: 130,
    },
    {
      title: this.L("MinValue1"),
      key: "t1Min",
      width: 130,
    },
    {
      title: this.L("MaxValue2"),
      key: "t2Max",
      width: 130,
    },
    {
      title: this.L("MinValue2"),
      key: "t2Min",
      width: 130,
    },
    {
      title: this.L("MaxValue3"),
      key: "t3Max",
      width: 130,
    },
    {
      title: this.L("MinValue3"),
      key: "t3Min",
      width: 130,
    },
    {
      title: this.L("MaxValue4"),
      key: "t4Max",
      width: 130,
    },
    {
      title: this.L("MinValue4"),
      key: "t4Min",
      width: 130,
    },
    {
      title: this.L("MaxValue5"),
      key: "t5Max",
      width: 130,
    },
    {
      title: this.L("MinValue5"),
      key: "t5Min",
      width: 130,
    },
    {
      title: this.L("MaxValue6"),
      key: "t6Max",
      width: 130,
    },
    {
      title: this.L("MinValue6"),
      key: "t6Min",
      width: 130,
    },
    {
      title: this.L("MaxValue7"),
      key: "t7Max",
      width: 130,
    },
    {
      title: this.L("MinValue7"),
      key: "t7Min",
      width: 130,
    },
    {
      title: this.L("MaxValue8"),
      key: "t8Max",
      width: 130,
    },
    {
      title: this.L("MinValue8"),
      key: "t8Min",
      width: 130,
    },
    {
      title: this.L("MaxValue9"),
      key: "t9Max",
      width: 130,
    },
    {
      title: this.L("MinValue9"),
      key: "t9Min",
      width: 130,
    },
    {
      title: this.L("MaxValue10"),
      key: "t10Max",
      width: 130,
    },
    {
      title: this.L("MinValue10"),
      key: "t10Min",
      width: 130,
    },
    {
      title: this.L("MaxValue11"),
      key: "t11Max",
      width: 130,
    },
    {
      title: this.L("MinValue11"),
      key: "t11Min",
      width: 130,
    },
    {
      title: this.L("MaxValue12"),
      key: "t12Max",
      width: 130,
    },
    {
      title: this.L("MinValue12"),
      key: "t12Min",
      width: 130,
    },
    {
      title: this.L("MaxValue13"),
      key: "t13Max",
      width: 130,
    },
    {
      title: this.L("MinValue13"),
      key: "t13Min",
      width: 130,
    },
    {
      title: this.L("MaxValue14"),
      key: "t14Max",
      width: 130,
    },
    {
      title: this.L("MinValue14"),
      key: "t14Min",
      width: 130,
    },
    {
      title: this.L("MaxValue15"),
      key: "t15Max",
      width: 130,
    },
    {
      title: this.L("MinValue15"),
      key: "t15Min",
      width: 130,
    },
    {
      title: this.L("MaxValue16"),
      key: "t16Max",
      width: 130,
    },
    {
      title: this.L("MinValue16"),
      key: "t16Min",
      width: 130,
    },
    {
      title: this.L("MaxValue17"),
      key: "t17Max",
      width: 130,
    },
    {
      title: this.L("MinValue17"),
      key: "t17Min",
      width: 130,
    },
    {
      title: this.L("MaxValue18"),
      key: "t18Max",
      width: 130,
    },
    {
      title: this.L("MinValue18"),
      key: "t18Min",
      width: 130,
    },
    {
      title: this.L("MaxValue19"),
      key: "t19Max",
      width: 130,
    },
    {
      title: this.L("MinValue19"),
      key: "t19Min",
      width: 130,
    },
    {
      title: this.L("MaxValue20"),
      key: "t20Max",
      width: 130,
    },
    {
      title: this.L("MinValue20"),
      key: "t20Min",
      width: 130,
    },
    {
      title: this.L("MaxValue21"),
      key: "t21Max",
      width: 130,
    },
    {
      title: this.L("MinValue21"),
      key: "t21Min",
      width: 130,
    },
    {
      title: this.L("MaxValue22"),
      key: "t22Max",
      width: 130,
    },
    {
      title: this.L("MinValue22"),
      key: "t22Min",
      width: 130,
    },
    {
      title: this.L("MaxValue23"),
      key: "t23Max",
      width: 130,
    },
    {
      title: this.L("MinValue23"),
      key: "t23Min",
      width: 130,
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 180,
      fixed: "right",
      render: (h: any, params: any) => {
        let del = this.checkButtonAuth('deviceWaringValueDel');
        let edit = this.checkButtonAuth('deviceWaringValueEdit');
        let copy = this.checkButtonAuth('deviceWaringValueCopy')
        return h("div", [
          copy ? h(
            "Button",
            {
              props: {
                type: "success",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("devicewaringvalue/edit", params.row);
                  this.copy();
                },
              },
            },
            this.L("Copy")
          ) : '',
          edit ? h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("devicewaringvalue/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ) : '',
          del ? h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "devicewaringvalue/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ) : '',
        ]);
      },
    },
  ];
  async created() {
    this.getAreaTree();
    this.getpage();
    this.pagerequest.isEnabel = 9;
  }
  data() {
    return {
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
